import { render } from "./SpmTableControlsPanel.vue?vue&type=template&id=cec4d660"
import script from "./SpmTableControlsPanel.vue?vue&type=script&lang=ts"
export * from "./SpmTableControlsPanel.vue?vue&type=script&lang=ts"

import "./SpmTableControlsPanel.vue?vue&type=style&index=0&id=cec4d660&lang=scss"
script.render = render

export default script